var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { NodesModel } from '../models/nodes-model.interface';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AiTaggingRepository } from '../repositories/ai-tagging-repository.interface';
import _ from 'lodash';
let NodesServiceImpl = class NodesServiceImpl {
    constructor(_aiTaggingRepository, _nodesModel) {
        this._aiTaggingRepository = _aiTaggingRepository;
        this._nodesModel = _nodesModel;
    }
    getNodes() {
        return this._nodesModel.nodeList;
    }
    initNodes(folderId, fieldId) {
        return this._aiTaggingRepository.getNodes(folderId, fieldId).then(nodes => {
            this._nodesModel.updateNodeList(nodes);
            return nodes;
        });
    }
    getIdsByNodes(nodes) {
        let ids = [];
        nodes.forEach(node => {
            ids.push(node.id);
            if (node.children) {
                ids = ids.concat(this.getIdsByNodes(node.children));
            }
        });
        return ids;
    }
    getSelectedNodes(nodes, selectedIds) {
        const filterNodes = (node) => {
            const filteredChildren = node.children?.map(filterNodes).filter(child => child !== null);
            if (selectedIds.includes(node.id) || filteredChildren?.length > 0) {
                return {
                    ...node,
                    children: filteredChildren?.length > 0 ? filteredChildren : undefined,
                };
            }
            return null;
        };
        // 处理所有根级节点
        return nodes.map(filterNodes).filter(node => node !== null);
    }
    getAllParentIds(nodes, targetId) {
        function dfs(nodes, path) {
            for (const child of nodes) {
                if (child.id === targetId) {
                    return path;
                }
                let result = null;
                if (child.children) {
                    result = dfs(child.children, [...path, child]);
                }
                if (result !== null) {
                    return result;
                }
            }
            return null;
        }
        const result = dfs(nodes, []);
        return _.map(result, item => item.id);
    }
    subscribeNodes(callback) {
        return this._nodesModel.onStatesChange(callback);
    }
};
NodesServiceImpl = __decorate([
    injectable(),
    __param(0, inject(AiTaggingRepository)),
    __param(1, inject(NodesModel)),
    __metadata("design:paramtypes", [typeof (_a = typeof AiTaggingRepository !== "undefined" && AiTaggingRepository) === "function" ? _a : Object, typeof (_b = typeof NodesModel !== "undefined" && NodesModel) === "function" ? _b : Object])
], NodesServiceImpl);
export { NodesServiceImpl };
